import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

const VideoIdeaService = {
  async list({ status, niche, page, limit } = {}) {
    const params = {};
    if (status) params.status = status;
    if (niche) params.niche = niche;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    return (await axios.get(`${API_BASE_URL}/video-ideas`, { params })).data;
  },
  async thumbnail(id) {
    return (await axios.get(`${API_BASE_URL}/video-ideas/${id}/thumbnail`, { responseType: 'blob' })).data;
  },
  async remove(id) {
    await axios.delete(`${API_BASE_URL}/video-ideas/${id}`);
  },
  async ideation() {
    return (await axios.get(`${API_BASE_URL}/video-ideas/ideation`)).data;
  },
  async requestIdeas(count) {
    return (await axios.post(`${API_BASE_URL}/video-ideas/ideation/runs`, { count })).data;
  },
  apiUrl() {
    return new URL(`${API_BASE_URL}/video-ideas`, window.location.origin).toString();
  },
};

export default VideoIdeaService;
